import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'searcher',
  templateUrl: './searcher.component.html',
  styleUrls: ['./searcher.component.css']
})
export class SearcherComponent implements OnInit {

  public esbusqueda = false;
  @Input() campoBusqueda = '';
  @Output() buscar: EventEmitter<any>;

  constructor() {
    this.buscar = new EventEmitter;
  }

  ngOnInit() {
    if(this.campoBusqueda !== '') {
      this.esbusqueda = true;
    }
  }

  search() {
    this.buscar.emit(this.campoBusqueda);
  }

  restoreTable() {
    this.esbusqueda = false;
    this.campoBusqueda = '';
    this.search();
  }

}
